<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: Collapsible beginner-help box for CW wizard steps; collapses in Express-Modus (TM-1000001889).
-->
@if (expanded) {
    <!-- Full help: shown always in normal mode, on-demand in Express -->
    <div class="cw-step-help flex align-items-start gap-2 p-3 mb-3 border-round-lg surface-100">
        <i class="fa-regular fa-circle-info text-primary mt-1"></i>
        <span class="text-sm text-color-secondary flex-1">
            <ng-content></ng-content>
        </span>
        @if (expressMode) {
            <!-- In Express the user can collapse the help again -->
            <i class="fa-regular fa-chevron-up text-color-secondary cursor-pointer mt-1"
               (click)="toggle()"
               pTooltip="Hilfetext einklappen"
               tooltipPosition="left"></i>
        }
    </div>
} @else {
    <!-- Collapsed (Express default): small (i) to expand the help on demand -->
    <button type="button"
            class="cw-step-help-collapsed flex align-items-center gap-2 mb-3 p-0 border-none bg-transparent cursor-pointer text-color-secondary"
            (click)="toggle()"
            pTooltip="Hilfetext anzeigen"
            tooltipPosition="right">
        <i class="fa-regular fa-circle-info text-primary"></i>
        <span class="text-xs">Hilfe anzeigen</span>
    </button>
}
